import { Button, TextField } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { useTrackingActions } from "@ryde/redux";
import {
  generateDebugTrackingInfos,
  IRideDto,
  IRideRoute,
  Log,
  normalizeAndSortLocations,
} from "@ryde/shared";

interface IMapToolboxDebugControls {
  rideDto?: IRideDto;
  routes: IRideRoute[];
}

const DEFAULT_GENERATE_COUNT = 4;

export const MapToolboxDebugControls: FC<IMapToolboxDebugControls> = ({
  rideDto,
  routes,
}) => {
  const { t } = useTranslation();
  const { setTrackingAtomData } = useTrackingActions();
  const [numGenerate, setNumGenerate] = useState(DEFAULT_GENERATE_COUNT);

  const fillTrackingsHandler = (): void => {
    const rideId = rideDto?.id || 0;
    const locations = normalizeAndSortLocations(routes?.[0]?.locations || []);
    const numberToGenerate = +numGenerate || DEFAULT_GENERATE_COUNT;
    const trackings = generateDebugTrackingInfos(
      locations,
      numberToGenerate,
      rideId,
    );
    Log.debug("Generated trackings", trackings);
    setTrackingAtomData(rideId, trackings);
  };

  return (
    <>
      <Button
        className="generate-points-button"
        variant="outlined"
        size="small"
        onClick={fillTrackingsHandler}
      >
        {t("rideMap.DEBUG_TOOLBOX_GENERATE")}
      </Button>
      <TextField
        variant="outlined"
        size="small"
        className="map-toolbox-counter-input"
        value={numGenerate}
        onChange={e =>
          setNumGenerate(+e.target.value || DEFAULT_GENERATE_COUNT)
        }
      />
    </>
  );
};
